import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const TargetingFilters = ({ onApplyFilters, onResetFilters }) => {
  const [filters, setFilters] = useState({
    minFollowers: '',
    maxFollowers: '',
    minEngagementRate: '',
    maxEngagementRate: '',
    industries: [],
    locations: [],
    verifiedOnly: false,
    activeInLast: '7'
  });

  const industryOptions = [
    { value: 'technology', label: 'Technology' },
    { value: 'marketing', label: 'Marketing' },
    { value: 'finance', label: 'Finance' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'education', label: 'Education' },
    { value: 'retail', label: 'Retail' },
    { value: 'entertainment', label: 'Entertainment' },
    { value: 'sports', label: 'Sports' }
  ];

  const locationOptions = [
    { value: 'us', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'ca', label: 'Canada' },
    { value: 'au', label: 'Australia' },
    { value: 'in', label: 'India' },
    { value: 'de', label: 'Germany' },
    { value: 'fr', label: 'France' },
    { value: 'jp', label: 'Japan' }
  ];

  const activityOptions = [
    { value: '1', label: 'Last 24 hours' },
    { value: '7', label: 'Last 7 days' },
    { value: '30', label: 'Last 30 days' },
    { value: '90', label: 'Last 90 days' }
  ];

  const handleApply = () => {
    onApplyFilters(filters);
  };

  const handleReset = () => {
    const resetFilters = {
      minFollowers: '',
      maxFollowers: '',
      minEngagementRate: '',
      maxEngagementRate: '',
      industries: [],
      locations: [],
      verifiedOnly: false,
      activeInLast: '7'
    };
    setFilters(resetFilters);
    onResetFilters();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Targeting Filters</h2>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          onClick={handleReset}
        >
          Reset
        </Button>
      </div>
      <div className="space-y-6">
        <div>
          <h3 className="text-sm font-medium text-foreground mb-3">Follower Count</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              type="number"
              label="Minimum"
              placeholder="e.g., 1000"
              value={filters?.minFollowers}
              onChange={(e) => setFilters({ ...filters, minFollowers: e?.target?.value })}
            />
            <Input
              type="number"
              label="Maximum"
              placeholder="e.g., 100000"
              value={filters?.maxFollowers}
              onChange={(e) => setFilters({ ...filters, maxFollowers: e?.target?.value })}
            />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-foreground mb-3">Engagement Rate (%)</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Input
              type="number"
              label="Minimum"
              placeholder="e.g., 2"
              value={filters?.minEngagementRate}
              onChange={(e) => setFilters({ ...filters, minEngagementRate: e?.target?.value })}
            />
            <Input
              type="number"
              label="Maximum"
              placeholder="e.g., 10"
              value={filters?.maxEngagementRate}
              onChange={(e) => setFilters({ ...filters, maxEngagementRate: e?.target?.value })}
            />
          </div>
        </div>

        <Select
          label="Industries"
          description="Select target industries"
          multiple
          searchable
          clearable
          options={industryOptions}
          value={filters?.industries}
          onChange={(value) => setFilters({ ...filters, industries: value })}
        />

        <Select
          label="Locations"
          description="Select target locations"
          multiple
          searchable
          clearable
          options={locationOptions}
          value={filters?.locations}
          onChange={(value) => setFilters({ ...filters, locations: value })}
        />

        <Select
          label="Active in"
          description="User activity timeframe"
          options={activityOptions}
          value={filters?.activeInLast}
          onChange={(value) => setFilters({ ...filters, activeInLast: value })}
        />

        <Checkbox
          label="Verified accounts only"
          description="Target only verified users"
          checked={filters?.verifiedOnly}
          onChange={(e) => setFilters({ ...filters, verifiedOnly: e?.target?.checked })}
        />

        <Button
          variant="default"
          fullWidth
          iconName="Search"
          iconPosition="left"
          onClick={handleApply}
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default TargetingFilters;